
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";

/**
 * PurchaseCardService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PurchaseCardService<T = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    DeletePurchaseCard(pId: string): Promise<void> {
        return this.$apiService.sendAuth("IPurchaseCardService/DeletePurchaseCard", pId);
    }
    GetPCApprovalMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPurchaseCardService/GetPCApprovalMetadata");
    }
    GetPCFieldMetadata(fixedWidth: boolean): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPurchaseCardService/GetPCFieldMetadata", fixedWidth);
    }
    GetPCTemplateMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPurchaseCardService/GetPCTemplateMetadata");
    }
    PopulateErrors(pId: number): Promise<T> {
        return this.$apiService.sendAuth("IPurchaseCardService/PopulateErrors", pId);
    }
}
